import * as React from 'react';
import './style.css';

import FooterContainer from './Components';

class Footer extends React.Component<{}, {}> {
  render() {
    return (
        <FooterContainer />
    );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Scenes/HomePage/Components/Footer/index.tsx